var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "cart",
      class: { "cart--visible": _vm.open, "cart-loader": _vm.show_loader },
      attrs: { id: "shop-cart" },
    },
    [
      _c("div", { staticClass: "cart__container" }, [
        _c(
          "a",
          {
            staticClass: "cart__close",
            attrs: { href: "#" },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.closeCart.apply(null, arguments)
              },
            },
          },
          [
            _c(
              "svg",
              {
                staticClass: "cart__close__ico",
                attrs: {
                  width: "16px",
                  height: "16px",
                  viewBox: "0 0 16 16",
                  version: "1.1",
                  xmlns: "http://www.w3.org/2000/svg",
                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                },
              },
              [
                _c("title", [_vm._v("7761595A-79BC-4696-9D3B-F79F423E42FD")]),
                _vm._v(" "),
                _c("desc", [_vm._v("Created with sketchtool.")]),
                _vm._v(" "),
                _c(
                  "g",
                  {
                    attrs: {
                      id: "desktop_design",
                      stroke: "none",
                      "stroke-width": "1",
                      fill: "none",
                      "fill-rule": "evenodd",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  },
                  [
                    _c(
                      "g",
                      {
                        attrs: {
                          id: "cart",
                          transform: "translate(-512.000000, -28.000000)",
                          stroke: "#93999C",
                          "stroke-width": "1.4",
                        },
                      },
                      [
                        _c(
                          "g",
                          {
                            attrs: {
                              id: "icon/closeGrey",
                              transform: "translate(513.000000, 29.000000)",
                            },
                          },
                          [
                            _c("line", {
                              attrs: {
                                x1: "14",
                                y1: "0",
                                x2: "0",
                                y2: "14",
                                id: "Stroke-429",
                              },
                            }),
                            _vm._v(" "),
                            _c("line", {
                              attrs: {
                                x1: "14",
                                y1: "14",
                                x2: "0",
                                y2: "0",
                                id: "Stroke-430",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "cart__header mb-5 pb-3" }, [
          _c(
            "h3",
            {
              staticClass:
                "font__family--gotham font__weight--medium font__color--gray cart__title",
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("cart", "cart")) +
                  "\n            "
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "cart__content" }, [
          _c("div", { staticClass: "d-flex justify-content-between" }, [
            _c("div", { staticClass: "cart__content__total mb-5" }, [
              _c(
                "p",
                {
                  staticClass:
                    "mb-0 cart__content__total__text font__family--gotham font__weight--light font__color--gray",
                },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t("payment_sum", "cart"))
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticClass:
                    "mb-0 cart__content__price font__family--gotham font__weight--medium font__color--gray",
                },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.total_cost) +
                      " " +
                      _vm._s(_vm.get_currency)
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", {}, [
              _c(
                "a",
                {
                  staticClass:
                    "button button__size-1 button__new button__new--blue",
                  class: { disabled: !_vm.checkout_link },
                  attrs: { href: _vm.checkout_link },
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "d-none d-lg-inline-block mr-2",
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "22",
                        height: "15",
                        viewBox: "0 0 22 15",
                      },
                    },
                    [
                      _c("g", [
                        _c("g", [
                          _c("path", {
                            attrs: {
                              fill: "none",
                              stroke: "#ffffff",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-miterlimit": "20",
                              "stroke-width": "1.4",
                              d: "M1 7v0l7 7v0L21 1v0",
                            },
                          }),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass:
                        "font__family--gotham font__weight--medium font__color--white",
                    },
                    [_vm._v(_vm._s(_vm.$t("checkout", "cart")))]
                  ),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            _vm._l(_vm.product_items, function (item, index) {
              return _c("cart-product", {
                key: "cart-product-" + index,
                attrs: { item: item },
              })
            }),
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "border__top border__color--gray py-4 mt-3 d-flex justify-content-between",
          },
          [
            _c(
              "p",
              {
                staticClass:
                  "mb-0 cart__content__total__text font__family--gotham font__weight--light font__color--gray",
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("delivery", "checkout")) +
                    "\n            "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "p",
              {
                staticClass:
                  "mb-0 cart__content__price font__family--gotham font__weight--medium font__color--gray",
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.show_shipment_price.toFixed(2)) +
                    " " +
                    _vm._s(_vm.get_currency) +
                    "\n            "
                ),
              ]
            ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }